import { extractErrorMessage } from 'app/providers/with-wagmi-auth/utils';
import { modalModel } from 'entities/modal';
import { createAppAsyncThunk, getScannerTxLink, logger, tap2mineReferralContract, wagmiConfig } from 'shared';
import { Address } from 'viem';
import { getChainId, waitForTransactionReceipt, writeContract } from 'wagmi/actions';

import { actionTypes } from '../action-types';

import { getClaimableAmount } from './get-claimable-amount';

export const claimReward = createAppAsyncThunk(
  actionTypes.CLAIM_REWARD,
  async (account: Address, { dispatch, rejectWithValue }) => {
    try {
      dispatch(
        modalModel.actions.openModal({
          type: modalModel.ModalType.Send,
          transition: 'fade',
        }),
      );

      const hash = await writeContract(wagmiConfig, {
        abi: tap2mineReferralContract.abi,
        address: tap2mineReferralContract.address,
        functionName: 'claim',
        account,
      });

      await waitForTransactionReceipt(wagmiConfig, { hash, confirmations: 2 });

      await dispatch(getClaimableAmount(account));

      dispatch(
        modalModel.actions.openModal({
          type: modalModel.ModalType.SendSuccess,
          data: {
            transactionLink: getScannerTxLink(getChainId(wagmiConfig), hash),
          },
          transition: 'fade',
        }),
      );

      return null;
    } catch (error) {
      logger(actionTypes.CLAIM_REWARD, error);

      dispatch(
        modalModel.actions.openModal({
          type: modalModel.ModalType.SendReject,
          transition: 'fade',
        }),
      );

      throw new Error(extractErrorMessage(error)); // TODO: add error middleware to parse errors centralized
    }
  },
);
